import type { KindMark } from "@/lib/dispositions";
import { cn } from "@/lib/utils";

/**
 * The icon beside an outcome's label: an alarm clock for a callback, an hourglass for a hold, a
 * phone off for no more calls, a ban for do-not-call (`outcomeMark` in `lib/dispositions.ts`).
 * Nothing for a retry. One muted colour for all of them, whether chosen or not; a hover says what
 * it stands for.
 */
export function KindIcon({ mark, className }: { mark: KindMark | null; className?: string }) {
  if (!mark) return null;
  const Icon = mark.icon;
  return (
    <span title={mark.label} className="inline-flex shrink-0">
      <Icon className={cn("size-3.5 text-text-muted", className)} aria-hidden />
    </span>
  );
}
